import { GenericLazyString } from '@eventbrite/i18n';
import { PARENT_CATEGORY_CONTENT_MAP } from './categoryImages';
import { FORMATTED_SUBCATEGORY_MAP } from './subcategories';

interface CategoryContent {
    title: string | GenericLazyString;
    key: string;
    imageUrl: string;
    subtitle?: string;
    theme?: string;
}

export const CATEGORY_CONTENT_MAP: Record<string, CategoryContent> = {
    ...PARENT_CATEGORY_CONTENT_MAP,
    ...FORMATTED_SUBCATEGORY_MAP,
};
